import React, { Component, useRef } from 'react';
import { connect } from 'react-redux';
import HomeNav from "components/Navbars/HomeNav.js";
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import {Modal} from "react-bootstrap";
import queryString from 'query-string';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

// reactstrap components
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Label,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Button
} from "reactstrap";

// core components
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
//import PlacesAutoComplete from "components/GoogleMapsAutoComplete/PlacesAutoComplete.js";
import { 
  patientFormSubmitAction, 
  patientFetchAction, 
  patientVerifyAction } 
from 'actions/patientActions';
import * as types from 'actions';
const moment = require('moment');

class PatientForm extends Component {
  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
    this.state = {
      firstFocus: false,
      lastFocus: false,
      show: false,
      modalOKEnabled: false,
      accessMode: '',
      patientRequestId: '',
      isSuccess: false,
      agreement: false
    }
    this.setShow = this.setShow.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    //this.handleChangeAgreement = this.handleChangeAgreement.bind(this);
    //this.setAgreement = this.setAgreement.bind(this);
  }

  componentWillMount() {
    document.title = 'Liquid Love Patient';
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let params = queryString.parse(this.props.location.search);    
    this.state.patientRequestId = params.reqId;
    this.state.accessMode = params.accessMode;

    if (this.state.accessMode === 'admin' && !this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/patient?accessMode=admin&reqId=' + params.reqId;
    }
    
    const fetchPayload = {
      reqId: this.state.patientRequestId,
      token: this.props.response.login.userToken 
    };
    if (this.state.accessMode === 'admin' && this.props.response.login.isSignedIn)    
      this.props.dispatch(patientFetchAction(fetchPayload));
  }

  componentDidMount () {
    if(this.state.accessMode !== 'admin')
        loadCaptchaEnginge(6);
  }

  componentWillUnmount() {
    document.body.classList.remove("landing-page");
    document.body.classList.remove("sidebar-collapse");
    /*if(this.props.response.places.address !== 'undefined')
      this.props.response.places.address = '';
    
    if(this.props.response.address !== 'undefined')
      this.props.response.address = '';  
    */
    if(this.props.response.patient.response !== 'undefined')      
      delete this.props.response.patient.response;

      this.props.response.patient.noServiceResponse = false;
      this.props.response.patient.systemRemarks = '';
  }

  handleBackClick() {
    this.props.navigate('/liquidlove/requests');    
  }

  setShow(bool) {
    this.setState({ show: bool });
  }
  handleClose = () => { 
    this.setShow(false)
    if(this.state.accessMode === 'admin' && this.state.isSuccess)
      this.props.navigate('/liquidlove/patient-details?reqId=' + this.state.patientRequestId 
      + '&country=' + this.props.response.patient.country + '&state=' + this.props.response.patient.stateLocation
      + '&district=' + this.props.response.patient.district + '&status=' + this.props.response.patient.status); 
    else
      this.props.navigate('/liquidlove/home');
  };
  
  handleShow = () => { this.setShow(true) };
  
  render() {
    if (this.state.accessMode === 'admin' && !this.props.response.login.isSignedIn) {
      return <Navigate to={'/liquidlove/login'} />
    }
    
    let message;
    message = 'Sairam! Processing your request';
    if (this.props.response.hasOwnProperty('patient') &&
    this.props.response.patient.hasOwnProperty('response')){
      this.state.modalOKEnabled = true;
      if(this.props.response.patient.noServiceResponse){
        this.state.isSuccess = false;
        message = 'Sairam. Sorry! We are not able to save the details. Please try later.';
      }
      else if(this.props.response.patient.response.hasOwnProperty('error')){
        this.state.isSuccess = false;
        if(this.state.accessMode === 'admin' &&
          this.props.response.patient.response.status === 401)
          message = 'Your session has expired. Please login again'
        else if(this.props.response.patient.response.status === 400)
          message = this.props.response.patient.response.message;
        else
          message = 'Sairam. Sorry! We are not able to save the details. Please try later.';
      }
      else if(this.props.response.patient.response !== undefined &&
        this.props.response.patient.action === types.PATIENT_FETCH_SUCCESS){
          if(this.props.response.patient.status === 'Verified'){
            this.state.isSuccess = false;
            message = 'Sairam! Request already verified';
          }
      }
      else if(this.props.response.patient.response !== undefined){
        this.state.isSuccess = true;  
        this.state.accessMode === 'admin' ? 
            message = 'Sairam! Request saved successfully'
            : message = 'Sairam! Our prayers to Swami for your speedy recovery. Please get a request letter from hospital.'
      }
    }  
    
    let patientData;
    patientData = this.state.accessMode === 'admin' ?  this.props.response.patient : undefined;
    
    return (      
      <Formik enableReinitialize={true}
            initialValues={{
                fullName: patientData ? patientData.fullname : '',
                age: patientData ? patientData.age : undefined,
                gender: patientData ? patientData.gender : 'male',
                bloodGroup: patientData ? patientData.bloodGroup : 'Any',
                requiredBy: patientData ? patientData.requiredBy : 'dd-mm-yyyy',
                units: patientData ? patientData.units : undefined,
                hospitalName: patientData ? patientData.hospitalName : '',
                hospital: patientData ? patientData.hospital : '',
                pincode: patientData ? patientData.pincode : '',
                attender: patientData ? patientData.attender : '',
                email: patientData ? patientData.email : '',
                phone: patientData ? patientData.phone : '',
                purpose: patientData ? patientData.purpose : 'Others',
                notes: patientData ? patientData.notes : '',
                userCaptcha: '',
                feedback: patientData ? patientData.feedback : '',
                verify: 'Verified'
            }}
        validationSchema={Yup.object().shape({
          fullName: Yup.string()
            .required('full name is required'),
          age: Yup.string()                
            .required('age is required')
            .matches(/^[1-9]+[0-9]*$/, 'Please provide a valid number without zero at start'),
          units: Yup.string()                
            .required('Number of units is required')
            .matches(/^[1-9]+[0-9]*$/, 'Please provide a valid number without zero at start'),
          requiredBy: Yup.string()                
            .required('requiredBy is required')
            .test('requiredBy', 'Date format dd-mm-yyyy',value => {
            return moment(value,'DD-MM-YYYY',true).isValid();
          } ),
          attender: Yup.string()
            .required('attender name is required'),
          email: Yup.string()
            .email('email is invalid'),
          hospitalName: Yup.string()
            .required('hospital or blood bank name is required'),                      
          hospital: Yup.string()
            .required('hospital or blood bank address is required'),      
          pincode: Yup.string()                
            .required('hospital or blood bank pincode is required')
            .matches(/^[1-9]+[0-9]*$/, 'Please provide a valid pincode with only numbers and without preceding zero')
            .length(6,'Please enter 6 digits without any spaces'),
          phone: Yup.string()                
            .required('mobile number is required')
            .matches(/^[1-9]+[0-9]*$/, 'Please provide a valid mobile number with only numbers and without preceding zero')
            .length(10,'Please enter 10 digits without any spaces'),
          userCaptcha: Yup.string()                
          .test('userCaptcha', 'Invalid captcha',value => {
            if(this.state.accessMode === 'admin')
              return true;
            else  
              return (value && validateCaptcha(value,false));
        } ),
        })}
        onSubmit={fields => {
            let id = patientData ? patientData.id : undefined;            
            let fullname = fields.fullName;
            let age = fields.age;
            let gender = fields.gender;
            let email = fields.email;
            let bloodGroup = fields.bloodGroup;
            let requiredBy = fields.requiredBy;
            let units = fields.units;
            let hospitalName = fields.hospitalName;
            let hospital = fields.hospital;
            let pincode = fields.pincode;
            //let hospital = this.props.response.places.address;
            //let hospitalLat = this.props.response.places.latitude;
            //let hospitalLong = this.props.response.places.longitude;
            let attender = fields.attender;
            let phone = fields.phone;
            let purpose = fields.purpose;
            let notes = fields.notes;            
            let feedback = fields.feedback;
            let status = this.state.accessMode === 'admin' ? 
              this.props.response.patient.status === 'Open' ? fields.verify : patientData.status :
              'Open';
            let token = this.state.accessMode === 'admin' ? this.props.response.login.userToken : '';
          
            const data = {
              //fullname,age,gender,bloodGroup,requiredBy,units,hospital,hospitalLat,hospitalLong,attender,email,phone,purpose
              id,fullname,age,gender,bloodGroup,requiredBy,units,hospitalName,hospital,pincode,attender,email,phone,purpose,status,notes,feedback
            };

            const patientPayload = {
              data,
              token
            }
            
            if(this.state.accessMode === 'admin'){
                message = 'Sairam! Processing your request';
                this.handleShow();    
                this.props.dispatch(patientVerifyAction(patientPayload));
            }
            else{
              message = 'Sairam! Processing your request';
              this.handleShow();    
              this.props.dispatch(patientFormSubmitAction(patientPayload));          
            }
        }      
      }
        render={({ errors, status, touched }) => (
                              
          <div className="wrapper">
            <HomePageHeader />
            <HomeNav adminName={this.props.response.login.adminName}/>
            <div
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
                <Row>
                  <Card className="card-signup" data-background-color="blue">
                    <CardHeader className="text-center">
                        <CardTitle className="title-up" tag="h3">
                            Liquid Love Request
                            {this.state.accessMode === 'admin' ? this.props.response.patient && this.props.response.patient.status === 'Open' ? ' Verification' : ' Update' : ''}
                        </CardTitle>                  
                    </CardHeader>
                    <CardBody>
                      <Form>
                        <Modal
                        centered
                        show={this.state.show}
                        onHide={this.handleClose}
                        backdrop="static"
                        keyboard={false}
                        >
                          <Modal.Body>
                            {message}
                          </Modal.Body>
                          <Modal.Footer>
                            <Button disabled={!this.state.modalOKEnabled} className="btn btn-primary mr-2" variant="primary" onClick={this.handleClose}>
                              OK
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        {this.state.accessMode === 'admin' && this.props.response.patient ? 'Request status: ' + this.props.response.patient.status : ''}
                        <InputGroup
                          className={
                            "no-border input-lg" +
                            (this.state.firstFocus ? " input-group-focus" : "")
                          }
                        >
                            <InputGroupText>
                            full name
                            </InputGroupText>
                          <Field name="fullName" type="text" className={'form-control' + (errors.fullName && touched.fullName ? ' is-invalid' : '')} />
                          <ErrorMessage name="fullName" component="div" className="invalid-feedback" />
                        </InputGroup>
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          age
                          </InputGroupText>
                          <Field name="age" type="text" className={'form-control' + (errors.age && touched.age ? ' is-invalid' : '')} />
                          <ErrorMessage name="age" component="div" className="invalid-feedback" />
                        </InputGroup>
                        
                        <div role="group" aria-labelledby="my-radio-group">
                        <Label check>
                          <Field
                            id="male"
                            name="gender"
                            type="radio"
                            value="male"                            
                          ></Field>
                          male <span className="form-check-sign"></span>
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Label check>
                          <Field
                            id="female"
                            name="gender"
                            type="radio"
                            value="female"
                          ></Field>
                          female <span className="form-check-sign"></span>
                        </Label>                        
                      </div>
                      <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          blood group
                          </InputGroupText>
                        <Field 
                        className="no-border input-lg  input-group-focus"
                        name="bloodGroup" id="bloodGroup" component="select">
                          <option>Any</option>                          
                          <option>O+</option>
                          <option>O-</option>
                          <option>A+</option>
                          <option>A-</option>
                          <option>B+</option>
                          <option>B-</option>
                          <option>AB+</option>
                          <option>AB-</option>
                          <option>A1+</option>
                          <option>A1-</option>
                          <option>A1B+</option>
                          <option>A1B-</option>
                          <option>A2+</option>
                          <option>A2-</option>
                          <option>A2B+</option>
                          <option>A2B-</option>
                          <option>Hh</option>
                        </Field>
                        </InputGroup>
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          units
                          </InputGroupText>
                          <Field name="units" type="text" className={'form-control' + (errors.units && touched.units ? ' is-invalid' : '')} />
                          <ErrorMessage name="units" component="div" className="invalid-feedback" />
                        </InputGroup>                      
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                      >
                          <InputGroupText>
                          Required by
                          </InputGroupText>
                        <Field name="requiredBy" type="text" className={'form-control' + (errors.requiredBy && touched.requiredBy ? ' is-invalid' : '')} />
                        <ErrorMessage name="requiredBy" component="div" className="invalid-feedback" />
                        </InputGroup>
                                                  
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          hospital Or<br></br>blood bank<br/>name
                          </InputGroupText>
                          <Field name="hospitalName" type="text" className={'form-control' + (errors.hospitalName && touched.hospitalName ? ' is-invalid' : '')} />
                          <ErrorMessage name="hospitalName" component="div" className="invalid-feedback" />
                        </InputGroup>

                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          address
                          </InputGroupText>
                          <Field name="hospital" component="textarea" rows="10" className={'form-control' + (errors.hospital && touched.hospital ? ' is-invalid' : '')} />
                          <ErrorMessage name="hospital" component="div" className="invalid-feedback" />
                        </InputGroup>
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          pincode
                          </InputGroupText>
                          <Field name="pincode" type="text" className={'form-control' + (errors.pincode && touched.pincode ? ' is-invalid' : '')} />
                          <ErrorMessage name="pincode" component="div" className="invalid-feedback" />
                        </InputGroup>                                                                      
                     
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          patient's attender
                          </InputGroupText>
                          <Field name="attender" type="text" className={'form-control' + (errors.attender && touched.attender ? ' is-invalid' : '')} />
                          <ErrorMessage name="attender" component="div" className="invalid-feedback" />
                        </InputGroup>                      
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          mobile
                          </InputGroupText>
                          <Field name="phone" type="text" className={'form-control' + (errors.phone && touched.phone ? ' is-invalid' : '')} />
                          <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                        </InputGroup>                                                                      
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.lastFocus ? " input-group-focus" : "")
                        }
                        >
                            <InputGroupText>
                            email
                            </InputGroupText>
                          
                          <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                          <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </InputGroup>
                        <InputGroup
                        className={
                          "no-border input-lg" +
                          (this.state.firstFocus ? " input-group-focus" : "")
                        }
                        >
                          <InputGroupText>
                          purpose
                          </InputGroupText>
                        <Field 
                        className="no-border input-lg  input-group-focus"
                        name="purpose" id="purpose" component="select">
                          <option>Cancer treatment</option>
                          <option>Cardiac surgery</option>
                          <option>Dialysis</option>                          
                          <option>ENT or Eye related</option>
                          <option>Gastroenterology related</option>
                          <option>General weakness</option>
                          <option>Gynaecology related</option>
                          <option>Neuro surgery</option>
                          <option>New born delivery</option>
                          <option>Ortho  surgery</option>
                          <option>Others</option>
                        </Field>
                        </InputGroup>
                        <InputGroup
                          className={
                            "no-border input-sm" +
                            (this.state.firstFocus ? " input-group-focus" : "")
                          }
                          >
                            <InputGroupText>
                            notes
                            </InputGroupText>
                            <Field name="notes" type="textarea" className={'form-control' + (errors.notes && touched.notes ? ' is-invalid' : '')} />
                            <ErrorMessage name="notes" component="div" className="invalid-feedback" />
                        </InputGroup>
                        {this.state.accessMode === 'admin' ? '' :                        
                          <div><LoadCanvasTemplate reloadText="Reload" /></div>
                        }
                        {this.state.accessMode === 'admin' ? '' :                        
                        <InputGroup
                          className={
                            "no-border input-sm" +
                            (this.state.firstFocus ? " input-group-focus" : "")
                          }
                          >
                            <InputGroupText>
                            Captcha
                            </InputGroupText>
                            <Field name="userCaptcha" type="textarea" className={'form-control' + (errors.userCaptcha && touched.userCaptcha ? ' is-invalid' : '')} />
                            <ErrorMessage name="userCaptcha" component="div" className="invalid-feedback" />
                        </InputGroup>                        
                        }
                        {this.state.accessMode === 'admin' ? '' :
                          <form><input onChange={e => {this.buttonRef.current.disabled = !e.target.checked}} name="agreement" type="checkbox" />
                          &nbsp;I voluntarily share the information</form>                                                   
                        }
                        
                        {this.state.accessMode === 'admin' ? 
                              <InputGroup
                              className={
                                "no-border input-sm" +
                                (this.state.firstFocus ? " input-group-focus" : "")
                              }
                              >
                                <InputGroupText>
                                feedback
                                </InputGroupText>
                                <Field name="feedback" type="textarea" className={'form-control' + (errors.feedback && touched.feedback ? ' is-invalid' : '')} />
                                <ErrorMessage name="feedback" component="div" className="invalid-feedback" />
                            </InputGroup>                            
                            : '' }
                            {this.state.accessMode === 'admin' && this.props.response.patient.status === 'Open' ? 
                            <div role="group" aria-labelledby="my-radio-group">
                              <Label check>
                                <Field
                                  id="Verified"
                                  name="verify"
                                  type="radio"
                                  value="Verified"                            
                                ></Field>
                                Valid request <span className="form-check-sign"></span>
                              </Label>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <Label check>
                                <Field
                                  id="Cancelled-Closed"
                                  name="verify"
                                  type="radio"
                                  value="Cancelled-Closed"
                                ></Field>
                                Invalid request <span className="form-check-sign"></span>
                              </Label>                        
                            </div>
                            : '' }                            
                        <div className="form-group">                        
                            <button type="submit" ref={this.buttonRef}
                            disabled={this.state.accessMode === 'admin' ? false : true}
                            className="btn btn-sm btn-primary mr-2">
                              {this.state.accessMode === 'admin' ? 
                                this.props.response.patient.status === 'Open' ? 'Verify' : 'Update' :
                                'Register'
                              }                              
                            </button>
                            <button type="reset" className="btn btn-sm btn-secondary">Reset</button>
                            {this.state.accessMode === 'admin' ? 
                              <Button className="btn btn-sm btn-primary mr-2" onClick={() => this.handleBackClick()}>Go to requests</Button>
                            : '' }
                        </div>                        
                      </Form>
                    </CardBody>                              
                </Card>
              </Row>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
      />
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  const location = useLocation();
  return <PatientForm navigate={navigate} location={location} {...props} />
});